import { AdvancedSybilCheckResponse } from '../../types/rewards';

export const advancedSybilCheckModel = (response: AdvancedSybilCheckResponse): AdvancedSybilCheckResponse => response;
